if (!customElements.get("native-product-customization")) {
  customElements.define(
    "native-product-customization",
    class NativeProductCustomization extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.section = this.closest("section");
        this.selectedVariantId = String(this.dataset.selectedVariantId || "");
        this.mattressLimit = Number(this.dataset.mattressLimit || 1);
        this.activeOptions = this.querySelector("[data-native-active-options]");
        this.variantGroups = new Map();

        this.addEventListener("click", (event) => this.onClick(event));
        this.addEventListener("change", (event) => this.onChange(event));
        this.section?.addEventListener("variantChangeEnd", (event) => {
          const picker = event.target.closest("variant-options") || event.target;
          const variantId = picker.currentVariant?.id || picker.dataset.variantId;
          if (variantId) this.updateForVariant(String(variantId));
        });
        this.updateForVariant(this.selectedVariantId);
      }

      updateForVariant(variantId) {
        this.selectedVariantId = String(variantId);
        this.dataset.selectedVariantId = this.selectedVariantId;

        const currentGroup = this.activeOptions?.querySelector(":scope > [data-native-group-for]");
        if (currentGroup?.dataset.nativeGroupFor !== this.selectedVariantId) {
          if (currentGroup) {
            this.variantGroups.set(currentGroup.dataset.nativeGroupFor, currentGroup);
            currentGroup.remove();
          }

          let nextGroup = this.variantGroups.get(this.selectedVariantId);
          if (!nextGroup) {
            const template = this.querySelector(
              `template[data-native-options-template-for="${CSS.escape(this.selectedVariantId)}"]`,
            );
            nextGroup = template?.content.firstElementChild?.cloneNode(true);
            if (nextGroup) this.variantGroups.set(this.selectedVariantId, nextGroup);
          }
          if (nextGroup) this.activeOptions?.replaceChildren(nextGroup);
        }

        this.activeOptions?.querySelectorAll("[data-native-addon-group-for]").forEach((group) => {
          if (!group.querySelector("[data-addon-select]:checked")) {
            const noneInput = group.querySelector('[data-addon-none="true"] [data-addon-select]');
            if (noneInput) noneInput.checked = true;
          }
          this.updateNoneSummary(group);
        });
      }

      onClick(event) {
        const accordionButton = event.target.closest(".native-product-customization__accordion-button");
        if (accordionButton && this.contains(accordionButton)) {
          const expanded = accordionButton.getAttribute("aria-expanded") === "true";
          const controls = accordionButton.getAttribute("aria-controls");
          const panel = controls ? this.querySelector(`#${CSS.escape(controls)}`) : null;
          accordionButton.setAttribute("aria-expanded", String(!expanded));
          if (accordionButton.lastElementChild) {
            accordionButton.lastElementChild.textContent = expanded ? "+" : "\u2212";
          }
          if (panel) panel.hidden = expanded;
          return;
        }

        const decreaseButton = event.target.closest("[data-addon-quantity-decrease]");
        if (decreaseButton && this.contains(decreaseButton)) {
          this.adjustQuantity(decreaseButton, -1);
          return;
        }

        const increaseButton = event.target.closest("[data-addon-quantity-increase]");
        if (increaseButton && this.contains(increaseButton)) {
          this.adjustQuantity(increaseButton, 1);
        }
      }

      onChange(event) {
        if (!event.target.matches("[data-addon-select], [data-addon-quantity], [data-addon-variant]")) return;
        if (event.target.matches("[data-addon-select]")) {
          this.enforceMattressLimit(event.target);
          this.enforceSingleCategorySelection(event.target);
          this.updateNoneSummary(event.target.closest("[data-native-addon-group-for]"));
        }
      }

      adjustQuantity(button, adjustment) {
        const input = button.closest("[data-addon-card]")?.querySelector("[data-addon-quantity]");
        if (!input) return;
        const current = Math.max(1, Number.parseInt(input.value || "1", 10) || 1);
        input.value = String(Math.max(1, current + adjustment));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }

      enforceMattressLimit(input) {
        const card = input.closest("[data-addon-card]");
        if (card?.dataset.addonCategory !== "mattress" || !input.checked || this.mattressLimit !== 1) return;
        this.querySelectorAll('[data-addon-category="mattress"] [data-addon-select]:checked').forEach((selected) => {
          if (selected !== input) selected.checked = false;
        });
      }

      enforceSingleCategorySelection(input) {
        const card = input.closest("[data-addon-card]");
        if (card?.dataset.addonSingleSelect !== "true" || !input.checked) return;
        const category = card.dataset.addonCategory;
        this.querySelectorAll(
          `[data-addon-card][data-addon-category="${CSS.escape(category)}"] [data-addon-select]:checked`,
        ).forEach((selected) => {
          if (selected !== input) selected.checked = false;
        });
      }

      updateNoneSummary(group) {
        const summary = group?.querySelector("[data-addon-none-summary]");
        if (!summary) return;
        const selectedAddon = [...group.querySelectorAll("[data-addon-card]:not([data-addon-none='true'])")].some(
          (card) => card.querySelector("[data-addon-select]")?.checked,
        );
        summary.textContent = selectedAddon ? " \u2014 Drawers selected" : " \u2014 No drawers required";
      }

      quantityFor(card) {
        return Math.max(1, Number.parseInt(card?.querySelector("[data-addon-quantity]")?.value || "1", 10) || 1);
      }

      selectedItems(groupId) {
        return [...this.querySelectorAll("[data-addon-card]")]
          .filter((card) => card.dataset.addonNone !== "true")
          .filter((card) => card.querySelector("[data-addon-select]")?.checked)
          .map((card) => {
            const selector = card.querySelector("[data-addon-variant]");
            const checkbox = card.querySelector("[data-addon-select]");
            return {
              id: Number(selector?.value || checkbox.value),
              quantity: this.quantityFor(card),
              properties: {
                _addon_group_id: groupId,
                _parent_product_id: String(this.dataset.productId),
                _parent_variant_id: this.selectedVariantId,
                _addon_category: card.dataset.addonCategory,
              },
            };
          });
      }
    },
  );
}
